import { useExperiment } from 'shared/experiment'

import { useDeusExMachina } from '~/domains/platform/infra/deus-ex-machina/hocs/with-deus-ex-machina'

export function useIsRecurrenceBoletoConfigEnabled() {
  const { deusExMachina } = useDeusExMachina()
  const subjectId = deusExMachina?.subject?.id ?? ''
  return useExperiment(subjectId, 'vc-recurrence-boleto-config-web', true)
}
